import React from 'react';
import Types from 'prop-types';
import { useIntl } from 'react-intl';
var FooterSmall = function FooterSmall(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement("div", {
    className: "row text-xs-center m-t-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-md-8 col-md-offset-2"
  }, items.map(function (_ref2) {
    var translationKey = _ref2.translationKey,
      addYear = _ref2.addYear;
    return /*#__PURE__*/React.createElement("p", {
      className: "body-3",
      key: translationKey
      // eslint-disable-next-line
      ,
      dangerouslySetInnerHTML: {
        __html: useIntl().formatMessage({
          id: translationKey
        }, addYear ? {
          year: new Date().getFullYear()
        } : null)
      }
    });
  })));
};
export default FooterSmall;